<template>
    <el-container class="c-comment">
        <el-main>
            <el-form ref="form" :model="newComment" class="c-comment-box">
                <el-form-item>
                    <el-input
                        rows="3"
                        type="textarea"
                        maxlength="300"
                        show-word-limit
                        v-model="newComment.content"
                        placeholder="参与讨论..."
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onSubmit"
                        class="u-publish"
                        >发表评论</el-button
                    >
                </el-form-item>
            </el-form>

            <div
                v-for="item in commentList"
                :key="item.comment.id"
                class="c-comment-list"
            >
                <Avatar
                    :avatar-size="68"
                    :user-avatar="showAvatar(item.user.avatar)"
                    :user-href="profileLink + item.user.id"
                    :username="item.user.displayName"
                />
                <CommmentWithReply
                    :item="item"
                    :post-id="postId"
                    :power="commentPower"
                    @deteleComment="deteleComment"
                />
            </div>

            <el-row v-if="commentList.length > 5">
                <el-col :span="12">
                    <el-form :inline="true" :model="newComment">
                        <el-form-item>
                            <el-input
                                show-word-limit
                                v-model="newComment.content"
                                placeholder="参与讨论"
                                style="width:360px"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit"
                                >提交</el-button
                            >
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="12">
                    <el-pagination
                        style="text-align:right"
                        background
                        hide-on-single-page
                        @current-change="handleCurrentChange"
                        :current-page.sync="pager.index"
                        :page-size="pager.pageSize"
                        layout="prev, pager, next, total"
                        :total="pager.total"
                    ></el-pagination>
                </el-col>
            </el-row>
        </el-main>
        <el-footer></el-footer>
    </el-container>
</template>

<script>
import { JX3BOX, Utils } from "@jx3box/jx3box-common";
import Avatar from "./components/avatar.vue";
import CommmentWithReply from "./components/comment-with-reply.vue";
import { GET, POST, DELETE } from "./service";
export default {
    name: "Comment",
    props: ["postId"],
    components: {
        Avatar,
        CommmentWithReply,
    },
    data: function() {
        return {
            commentPower: {
                allow: false,
                uid: -1,
            },
            commentList: [],
            showAvatar: Utils.showAvatar,
            profileLink: JX3BOX.__Links.author + "",
            newComment: {},
            pager: {
                index: 1,
                pageSize: 10,
                pageTotal: 1,
                total: 0,
            },
        };
    },
    methods: {
        deteleComment(id) {
            DELETE(`/api/post/${this.postId}/comment/${id}`)
                .then(() => {
                    this.$notify({
                        title: "",
                        message: "删除成功!",
                        type: "success",
                        duration: 3000,
                        position: "bottom-right",
                    });
                    this.reloadCommentList(this.pager.index);
                })
                .catch(() => {});
        },
        reloadCommentList(index) {
            GET(`/api/post/${this.postId}/comment/page/${index}`)
                .then((resp) => {
                    this.commentList = resp.data || [];
                    this.pager = resp.page;
                })
                .catch(() => {});
        },
        handleCurrentChange(gotoIndex) {
            this.reloadCommentList(gotoIndex);
        },
        onSubmit() {
            POST(`/api/post/${this.postId}/comment`, null, {
                content: this.newComment.content,
            })
                .then(() => {
                    this.$notify({
                        title: "",
                        message: "评论成功!",
                        type: "success",
                        duration: 3000,
                        position: "bottom-right",
                    });
                    this.newComment = {};
                    if (
                        this.pager.index == this.pager.pageTotal ||
                        this.pager.total % this.pager.pageSize == 0
                    ) {
                        this.reloadCommentList(this.pager.index);
                    }
                })
                .catch(() => {});
        },
    },

    mounted() {
        this.reloadCommentList(1);
        GET(`/api/post/${this.postId}/can-i-delete-comment`)
            .then((power) => {
                this.commentPower = power;
            })
            .catch(() => {});
    },
};
</script>

<style lang="less">
.c-comment-box {
    margin: 12px 0;
    border-bottom: 1px solid #eee;
    textarea {
        font-family: inherit;
    }
    .u-publish {
        float: right;
    }
}

.c-comment-list {
    padding: 10px 0;
    margin-bottom: 10px;
    border-bottom: 1px solid #eee;
    display: flex;
}
.c-comment-avatar {
    vertical-align: top;
    margin-right: 20px;
    width: 68px;
}
.c-comment-cmt {
  flex-grow:1;
}
</style>
